import { render, staticRenderFns } from "./SelectMultipleItems.vue?vue&type=template&id=c8082ad2&"
import script from "./SelectMultipleItems.vue?vue&type=script&lang=js&"
export * from "./SelectMultipleItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports